module.exports = "/_next/static/images/Firmware-2a923e1b4655e2ef29af380ecd959bf2.png";